export default __webpack_public_path__ + "static/media/parks-large.0955f856.svg";